import * as React from "react";
import DataComponent from "../common/DataComponent";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import FavoritedLabel from "./FavoritedLabel";
import { Link } from 'react-router-dom';
import MiniSpinner from "../common/MiniSpinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import DirectScheduleButton from "../appointments/DirectScheduleButton";
import OpenScheduleButton from "../care/OpenScheduleButton";
import MiniSearch from "../providers/MiniSearch";

class MyFavoriteProviders extends DataComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.providerCard = this.providerCard.bind(this);
        this.navToProvider = this.navToProvider.bind(this);

    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.MyFavoriteProviders.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    shouldLoadData() {
        const { IsLoggedIn, FavoriteProviders, fetchingFavoriteProviders } = this.props;
        return IsLoggedIn && !FavoriteProviders && !fetchingFavoriteProviders;
    }

    loadData() {
        const { loadFavoriteProviders } = this.props;
        loadFavoriteProviders();
    }

    navToProvider(e, npi) {
        if (e.target && e.target.classList && e.target.classList.contains("appt-time-more")) {
            e.preventDefault();
            return;
        }
        const { history } = this.props;
        history.push("/providers/" + npi);
    }

    providerCard(provider, index) {
        let location = null;
        let more = 0;
        if (provider.locations.length > 0) {
            location = provider.locations[0];
            more = provider.locations.length - 1;
        }
        let phone = provider.consumerCallCenterNumber;
        if (location && location.locationPhone && (!phone || phone === "")) {
            phone = location.locationPhone;
        }
        let { onlineSchedulingEnabled } = this.props;

        const apptTimesAmount = this.props.apptTimesAmount ? this.props.apptTimesAmount : 3;
        let schedule = [];
        let count = 0;
        let earliestAvailableDate = new Date();
        let today = new Date();
        let moreUrl = `/schedule/${provider.npi}/OpenSchedule`;

        if (provider.openSchedule && provider.openSchedule.dateAndTimes) {
            earliestAvailableDate = new Date(provider.openSchedule.dateAndTimes[0].date);

            for (var i = 0; i < provider.openSchedule.dateAndTimes.length; i++) {
                let dt = provider.openSchedule.dateAndTimes[i];
                for (var j = 0; j < dt.times.length; j++) {
                    count++;
                    if (count <= apptTimesAmount) {
                        schedule.push(<OpenScheduleButton npi={provider.npi} scheduleData={dt.times[j]} dayString={dt.dayString} key={count} />);
                    }
                    else {
                        break;
                    }
                }
                if (count > 3) { break; }
            }
        }

        //debugger;
        return (
            <div className="col-12 col-xl-6" key={provider && provider.npi ? provider.npi : index}>
                <div className="card docs">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 finger" onClick={(e) => { this.navToProvider(e, provider.npi) }}>
                                <div className="docs__img-container">
                                    <img alt={Tools.trimComma(provider.displayName) + " photo"} src={provider.photo || "/images/profile-pic.png"} />
                                </div>
                                <div className="row docs__info-container">
                                    <div className="col-12">
                                        <div className="docs__info-container--name">
                                            {Tools.trimComma(provider.displayName)}
                                        </div>
                                        <div className="docs__info-container--specialty">
                                            {provider.specialties.map((specialty) => {
                                                return specialty.Specialty;
                                            }).join(",")}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="docs__info-container--details show-schedule-options">
                                            <div className="details-icon-prepend">
                                                <div className="icon-col"><span className="icon-address" /></div>
                                                <div className="details-col">
                                                    <div>{location && location.locationCity + ", " + location.locationState + "   " + (more > 0 ? "(+" + more + " more)" : "")}</div> {/* Doc's main city and state + however many other locations they work at. Link to the doctor's details page. */}
                                                </div>
                                            </div>
                                            <div className="details-icon-prepend">
                                                {phone ?
                                                    <a className="phone-link" href={"tel:" + phone}>
                                                        <div className="icon-col"><span className="icon-phone" /></div>
                                                        <div className="details-col">
                                                            {phone}
                                                        </div>
                                                    </a>
                                                    : <React.Fragment>
                                                        <div className="icon-col"><span className="icon-phone" /></div>
                                                        <div className="details-col">
                                                            <div className="no-data-dash">
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                            <FavoritedLabel NPI={provider.npi} />
                                        </div>
                                        {
                                            //window.serverData.data.enableDirectScheduling &&
                                            <div className="docs__info-container--schedule">
                                                {
                                                    // // priority: direct scheduling button...
                                                    // window.serverData.data.enableDirectScheduling &&
                                                    //     this.props.directNpiList.includes(provider.npi) ? onlineSchedulingEnabled ?

                                                    //         //this.props.directNpiListPending === false &&
                                                    //         <DirectScheduleButton npi={provider.npi} /> :
                                                    //         <div className="call-appt-container">
                                                    //             {phone &&
                                                    //                 <a href={"tel:" + phone} className="phone-link">
                                                    //                     <div className="call-appt-text">Call to schedule</div>
                                                    //                 </a>
                                                    //             }
                                                    //         </div> : ''
                                                }
                                                {
                                                    // open scheduling buttons: if open is available and direct is not...
                                                    provider.isReferable === true &&
                                                    //this.props.directNpiList.includes(provider.npi) === false &&
                                                    //this.props.directNpiListPending === false &&
                                                    <React.Fragment>
                                                        {
                                                            provider.isOpenSchedulingAvailable && onlineSchedulingEnabled ?
                                                                <div className="item-times-container">
                                                                    {/*<div className="appt-time-list">
                                                                    {schedule}
                                                                </div>*/}
                                                                    <div className="appt-time-more appt-time-disabled">
                                                                        <button type="button" to={{ pathname: moreUrl }} className={"btn btn-primary " + ((provider.openSchedule && provider.openSchedule.dateAndTimes) ? "" : " disabled ")}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                logUI("MBHWeb.UI.MyFavoriteProviders.ScheduleMoreLinkClicked", new Date(), Tools.getURLPath());
                                                                                //window.location.href = moreUrl;
                                                                                this.props.history.push(moreUrl);
                                                                            }}>
                                                                            <span className="desktop-label">Schedule an Appointment</span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                : <div className="call-appt-container">
                                                                    {phone &&
                                                                        <a href={"tel:" + phone} className="phone-link">
                                                                            <div className="call-appt-text">Call to schedule</div>
                                                                        </a>
                                                                    }
                                                                </div>
                                                        }
                                                    </React.Fragment>
                                                }
                                                {
                                                    // provider that is non referable and does not have direct
                                                    provider.isReferable === false &&
                                                   // this.props.directNpiList.includes(provider.npi) === false &&
                                                    <div className="no-appt-container">
                                                        <div className="no-appt-text">Not available for appointments</div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }


    render() {
        const { FavoriteProviders } = this.props;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <h1 className="page-heading">Favorite Doctors</h1>
                    </div>
                </div>
                {
                    window.serverData.data.enableFavoriteSearch === true &&
                    <div className="row form-group minimal-style doctor-typeahead-container">
                        <div className="col-12">
                            <MiniSearch existingFavorites={this.props.FavoriteProviders} onFavorited={() => this.props.loadFavoriteProviders()} />
                        </div>
                    </div>
                }
                {
                    (!FavoriteProviders) ?
                        <MiniSpinner />
                        : FavoriteProviders.length === 0 ? <div className="row"><div className="col-12 no-favorites">No doctors have been favorited.</div></div> :
                            <React.Fragment>
                                {
                                    FavoriteProviders.map((providerRow, index) => {
                                        return (
                                            <div className="row row-card-eq" key={index}>
                                                <React.Fragment>
                                                    {
                                                        providerRow.map((provider, index2) => {
                                                            return this.providerCard(provider, index2);
                                                        })
                                                    }
                                                </React.Fragment>
                                            </div>);
                                    })
                                }
                            </React.Fragment>
                }
            </React.Fragment>


        );
    }

};



const mapStateToProps = (state, ownProps) => {
    return {
        UserName: state.domain.un,
        Token: state.domain.t,
        IsLoggedIn: state.domain.li,
        FavoriteProviders: state.healthSource.favoriteProvidersCards,
        fetchingFavoriteProviders: state.healthSource.fetchingFavoriteProviders,
        history: state.session.history,
        directNpiList: state.directScheduling.providerNpiList,
        directNpiListPending: state.directScheduling.providerListPending,
        onlineSchedulingEnabled: state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadFavoriteProviders: () => {
            //debugger;
            dispatch({
                type: types.GET_FAVORITE_PROVIDERS_START
            });
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyFavoriteProviders);